import { render, staticRenderFns } from "./UsersAside.vue?vue&type=template&id=2fafdcac"
import script from "./UsersAside.vue?vue&type=script&lang=js"
export * from "./UsersAside.vue?vue&type=script&lang=js"
import style0 from "./UsersAside.vue?vue&type=style&index=0&id=2fafdcac&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports